import React from 'react';
import { StyleInput } from './styles';

class InputsComponent extends React.Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
  }

render() {
  return (
  <StyleInput
    // placeholder={props.placeholder}
    type={this.props.type}
    onChange={this.handleChange} value={this.props.value} name={this.props.name} 
    onBlur={ this.handleOnBlur }
  />
  )
}
handleChange(event) {
  this.props.onChange(event.target); 
}

handleOnBlur(event){
  this.props.onBlur(event.target)
}

}

export default InputsComponent;